import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isProfileMenuOpen: false,
  isProfileModalOpen: false,
  isNavMenuOpen: false,
};

const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    setProfileMenuOpen(state, action) {
      state.isProfileMenuOpen = action.payload;
    },
    setProfileModalOpen(state, action) {
      state.isProfileModalOpen = action.payload;
    },
    setNavMenuOpen(state, action) {
      state.isNavMenuOpen = action.payload;
    },
  },
});

export const {
  setProfileMenuOpen,
  setProfileModalOpen,
  setNavMenuOpen,
} = headerSlice.actions;

export const selectHeaderProfileMenuOpen = (state) => state.header.isProfileMenuOpen;
export const selectHeaderProfileModalOpen = (state) => state.header.isProfileModalOpen;
export const selectHeaderNavMenuOpen = (state) => state.header.isNavMenuOpen;

export default headerSlice.reducer;
